import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {
	selectOlivioDesign, selectOlivioFuseBox, selectOlivioFuseBoxIsSatisfied,
} from '../olivioSelectors';
import {olivioFuseBoxOptions} from '../olivioModel';

@customElement('olivio-general-controller-settings')
export class OlivioGeneralControllerSettings extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--small-padding);
			}
			.box {
				background-color: var(--color-widget-background);
				padding: 12px;
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--large-space);
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.system = selectOlivioDesign(state);
	}

	render() {
		return html`
			<div class="box">
				<spc-attribute .attributeId=${{localId: 'EB_Control_1'}} .hideDisabled=${true} .excludedValues=${['CircularProfile']}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'EB_ConstantLumenTechnology_1'}} .hideDisabled=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'EB_Zhaga_1'}} .hideDisabled=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'EB_ElectricalProtectionClass_1'}} .hideDisabled=${true}></spc-attribute>
				<list-select
					.title=${{de: 'Kabelsicherungskasten', en: 'fuse box', fr: 'boitier fusible'}}
					.options=${olivioFuseBoxOptions}
					action='olivio/setFuseBox'
					.selected=${selectOlivioFuseBox}
					.canBeSelected=${() => true}
					.isSatisfied=${selectOlivioFuseBoxIsSatisfied}>
				</list-select>
			</div>
		`;
	}
}
